import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';
import { setError } from '../../../actions';
import { getStaticPage } from '../../../api/queries';
import { STATIC_SLUG } from '../../../utils/helpers/constants';
import { Typography } from '../../ui/Typography';
import { StaticContainer, StyledLink } from './styled';
import MarkdownToHtml from '../../Ad/MarkdownToHtml';
import { FlexCenterAligned } from '../../../styled/common';
import { StaticPlaceholder } from '../../Placeholders/StaticPlaceholder';

const options = {
  forceWrapper: true,
  wrapper: 'article',
  overrides: {
    br: { component: 'p' },
    h3: {
      component: Typography,
      props: { tag: 'header_bold' }
    },
    h2: {
      component: Typography,
      props: { tag: 'header_bold' }
    },
    p: {
      component: Typography,
      props: { tag: 'p' }
    },
    a: { component: StyledLink },
    strong: {
      component: Typography,
      props: { tag: 'bold' }
    }
  }
};

export const StaticPage = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const path = router.query.page;
  const slug = STATIC_SLUG[path];

  const { data, error, loading } = useQuery(getStaticPage, {
    variables: { slug }
  });

  useEffect(() => {
    if (error) {
      dispatch(setError(true));
    }
  }, [error]);

  return (
    <FlexCenterAligned>
      <StaticContainer>
        {loading ? (
          <StaticPlaceholder />
        ) : (
          <MarkdownToHtml markdown={data?.page?.content} options={options} />
        )}
      </StaticContainer>
    </FlexCenterAligned>
  );
};
